// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.combobox {
    display: inline-flex;
    align-items: center;
    user-select: none;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    border: 1px solid var(--border-color);
    background-color: var(--list-bg-color);
    height: 2em;
    position: relative;
}

div.combobox-invalid {
    background-color: #FFAAAA;
}

div.combobox > input {
    position: absolute;
    inset: 0;
    z-index: -10000;
    opacity: 0;
}

div.combobox-button {
    flex: 1 1 auto;
    display: flex;
    align-items: center;
    height: 100%;
    position: relative;
}

span.combobox-button-content {
    padding: 0 0.25em;
    flex: 1 1 auto;
    white-space: nowrap;
    line-height: 2em;
}

input.combobox-button-filter {
    position: absolute;
    z-index: 1;
    border: none!important;
    background-color: transparent!important;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
}

div.combobox-button > span.icon {
    font-size: 100%;
    flex: 0 0 1em;
    margin: 0.25em;
}

div.combobox-disabled div.combobox-button > span.icon {
    color: var(--text-color-disabled);
}

div.combobox-menu-entry {
    padding: 0.25em 0.5em;
}

div.combobox-menu-entry-active {
    background-color: var(--list-item-bg-color-active);
    color: var(--list-item-text-color-active);
}

div.combobox-menu-entry-active:focus {
    background-color: var(--list-item-bg-color-active-hover);
    color: var(--list-item-text-color-active-hover);
}

div.combobox-menu-entry-group-header {
    display: flex;
    background-color: var(--list-section-bg-color);
    color: var(--list-section-text-color);
    font-weight: bold;
}

div.combobox-menu-entry-group-header:focus {
    background-color: var(--list-section-bg-color-hover);
}

div.combobox-menu-entry-group-header > span.icon {
    flex: 0 0 auto;
}`, "",{"version":3,"sources":["webpack://./components/widgets/style/ComboBox.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,2BAA2B;IAC3B,yBAAyB;IACzB,qCAAqC;IACrC,sCAAsC;IACtC,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,eAAe;IACf,UAAU;AACd;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,sBAAsB;IACtB,uCAAuC;IACvC,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;AACb;;AAEA;IACI,eAAe;IACf,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kDAAkD;IAClD,yCAAyC;AAC7C;;AAEA;IACI,wDAAwD;IACxD,+CAA+C;AACnD;;AAEA;IACI,aAAa;IACb,8CAA8C;IAC9C,qCAAqC;IACrC,iBAAiB;AACrB;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,cAAc;AAClB","sourcesContent":["div.combobox {\n    display: inline-flex;\n    align-items: center;\n    user-select: none;\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    border: 1px solid var(--border-color);\n    background-color: var(--list-bg-color);\n    height: 2em;\n    position: relative;\n}\n\ndiv.combobox-invalid {\n    background-color: #FFAAAA;\n}\n\ndiv.combobox > input {\n    position: absolute;\n    inset: 0;\n    z-index: -10000;\n    opacity: 0;\n}\n\ndiv.combobox-button {\n    flex: 1 1 auto;\n    display: flex;\n    align-items: center;\n    height: 100%;\n    position: relative;\n}\n\nspan.combobox-button-content {\n    padding: 0 0.25em;\n    flex: 1 1 auto;\n    white-space: nowrap;\n    line-height: 2em;\n}\n\ninput.combobox-button-filter {\n    position: absolute;\n    z-index: 1;\n    border: none!important;\n    background-color: transparent!important;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n}\n\ndiv.combobox-button > span.icon {\n    font-size: 100%;\n    flex: 0 0 1em;\n    margin: 0.25em;\n}\n\ndiv.combobox-disabled div.combobox-button > span.icon {\n    color: var(--text-color-disabled);\n}\n\ndiv.combobox-menu-entry {\n    padding: 0.25em 0.5em;\n}\n\ndiv.combobox-menu-entry-active {\n    background-color: var(--list-item-bg-color-active);\n    color: var(--list-item-text-color-active);\n}\n\ndiv.combobox-menu-entry-active:focus {\n    background-color: var(--list-item-bg-color-active-hover);\n    color: var(--list-item-text-color-active-hover);\n}\n\ndiv.combobox-menu-entry-group-header {\n    display: flex;\n    background-color: var(--list-section-bg-color);\n    color: var(--list-section-text-color);\n    font-weight: bold;\n}\n\ndiv.combobox-menu-entry-group-header:focus {\n    background-color: var(--list-section-bg-color-hover);\n}\n\ndiv.combobox-menu-entry-group-header > span.icon {\n    flex: 0 0 auto;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
